module.exports = __webpack_public_path__ + "static/media/Spain.4668df99.png";